import React from 'react';
import {
  shape, string, bool, number, oneOf,
} from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { CardTitle, TileContent, TileText, Typography } from '@one-thd/sui-atomic-components';

export const Header = ({
  variant = 'default',
  pod = {},
  isInline = false
}) => {
  if (variant === 'product') {
    // <ProductPod>
    //   {slot}
    // </ProductPod>
    return (
      <ProductHeader
        itemId={pod.itemId}
        brand="above"
        disableShopThisCollection
        large={false}
        brandMaxLine={pod.brandMaxLine}
        brandTitleMaxLine={pod.brandTitleMaxLine}
        titleMaxLine={pod.titleMaxLine}
      />
    );
  }

  if (variant === 'card') {
    // <Card>
    //   <CardContent>
    //     {slot}
    //   </CardContent>
    // </Card>
    return (
      <CardTitle
        header={pod.header}
        subheader={pod.subheader}
        headerWeight={pod.headerWeight}
        padding={pod.padding}
      />
    );
  }

  if (variant === 'tile') {
    // <Tile>
    //   {slot}
    // </Tile>
    return (
      <TileContent>
        <TileText>{pod.header}</TileText>
        <TileText>{pod.subheader}</TileText>
      </TileContent>
    );
  }

  if (isInline) {
    // Inline text flow - renders as continuous text on same line
    return (
      <Typography variant="body-base" lineClamp={pod.titleMaxLine} height="normal">
        <span className="sui-font-bold">{pod.header}</span>
        {pod.header && pod.subheader && ' '}
        {pod.subheader}
      </Typography>
    );
  }

  // Stacked layout - bold text on top, regular text below
  return (
    <div className="sui-flex sui-flex-col">
      <Typography variant="body-lg" weight="bold" truncate>
        {pod.header}
      </Typography>
      <Typography variant="body-base" lineClamp={pod.titleMaxLine} height="normal">
        {pod.subheader}
      </Typography>
    </div>
  );
};

Header.propTypes = {
  variant: oneOf(['default', 'product', 'card', 'tile']).isRequired,
  pod: shape({
    // product
    itemId: string,
    brandMaxLine: number,
    brandTitleMaxLine: number,
    titleMaxLine: number,
    // card + tile
    header: string,
    subheader: string,
    // card
    headerWeight: oneOf(['bold', 'display']),
    padding: bool,
  }).isRequired,
  isInline: bool,
};

Header.defaultProps = {
  isInline: false,
};
